import React from "react";
import tabletImage from "../../components/LandingPage/images/tabImg.png"; // Update with your tablet image path

const StepThree = () => {
  return (
    <div>
      <div className="flex flex-col lg:flex-row justify-between items-center w-full py-12 px-2 ">
        {/* Left Section: Text */}
        <div className="lg:w-[30%]  text-center sm:text-left mb-8 lg:mb-0">
          <h1 className="text-3xl md:text-4xl font-raleway font-extrabold text-black">
            Exclusive <br></br>
            <span className="text-[#A67FAA] font-raleway">Seasonal </span>
            <br />
            Collections
          </h1>
          <p className="text-xl md:text-2xl mt-10 font-publicSans font-semibold  text-black">
            Discover new dishes every season with exclusive collections from
            celebrity chefs, guest contributors, and foodies just like you!{" "}
          </p>
        </div>

        {/* Right Section: Tablet Image */}
        <div className="lg:w-[70%] flex justify-end ">
          <img src={tabletImage} alt="Tablet" className="w-full max-w-2xl" />
        </div>
      </div>
    </div>
  );
};

export default StepThree;
